export default "__VITE_ASSET__Blsj1hz1__"